import * as React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { useGlobalAuthContext } from "../context/AuthContext";
import { Stack } from "@mui/material";
import { DynamicAlert } from "../utils/Alerts";
import { useState } from "react";
import { useUserProfileSelector } from "../hooks/useUserProfile";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useDispatch } from "react-redux";
import { apiRoomNate } from "../Slices/roomNateApis";
import { setUserProfile } from "../Slices/roomNateSlice";
import AccountProfileForm from "../Components/UserHome/AccountProfileForm";
import { getAuthorizationHeaderObject } from "../utils/authHeaders";

/**
 * Embedded in sketch-upload (My Account → Edit). Standalone `/edit` redirects to `/main`.
 */
export default function UpdateProfile({ setValue }) {
  if (setValue === undefined) {
    return <Navigate to="/main" replace />;
  }
  return <EmbeddedUpdateProfile setValue={setValue} />;
}

function EmbeddedUpdateProfile({ setValue }) {
  const { currentUserSessionStorage } = useGlobalAuthContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { userProfile: profile } = useUserProfileSelector();

  const [load, setLoad] = React.useState(false);
  const [title, setTitle] = useState("");
  const [status, setStatus] = useState(false);
  const [logoId, setLogoId] = useState(null);

  const authHeaders = () => getAuthorizationHeaderObject(currentUserSessionStorage);

  const formik = useFormik({
    initialValues: {
      name: profile?.name || "",
      email: profile?.email || "",
      disclaimer: profile?.disclaimer || "",
      role: "user",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string()
        .required("No email provided")
        .matches(
          "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$",
          "No correct email has been provided"
        ),
    }),
    onSubmit: async (values) => {
      setLoad(true);
      const payload = { ...values };
      if (payload?.logo?.startsWith?.("https")) delete payload.logo;
      if (logoId) payload.logo = logoId;
      try {
        await axios.put(
          "/user/update/",
          payload,
          {
            headers: authHeaders(),
          }
        );

        setLoad(false);
        dispatch(apiRoomNate.util.invalidateTags(["UserProfile"]));
        const { data } = await axios.get("user/getLoggedInUser", {
          headers: authHeaders(),
        });
        if (data) dispatch(setUserProfile(data));
        setValue("3");
      } catch (error) {
        setLoad(false);
        setTitle(error?.response?.data);
        setStatus(false);
        setTimeout(() => {
          setTitle("");
        }, 2000);
      }
    },
  });

  React.useEffect(() => {
    if (!currentUserSessionStorage) {
      navigate("/");
    }
  }, [currentUserSessionStorage, navigate]);

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {title?.length >= 1 && <DynamicAlert status={status} title={title} />}

      <Stack
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography className="big-header">
          Edit your account details
        </Typography>
      </Stack>

      <AccountProfileForm
        formik={formik}
        setLogoId={setLogoId}
        load={load}
        onCancel={() => setValue("3")}
      />
    </>
  );
}
